/**
 * Use the Strict Contextual Escaping service to allow raw HTML.
 *
 * HTML strings will be escaped if we insert them in the template
 * with braces {{myObj.htmlString}}
 *
 * @see https://docs.angularjs.org/api/ng/service/$sce
 */
const UnsafeFilter = angular.module("UnsafeFilter", []).filter("unsafe", [
    "$sce",
    function ($sce) {
        return function (value) {
            return $sce.trustAsHtml(value);
        };
    }
]);

export default UnsafeFilter;
